// src/api/registroApi.js
//
// Endpoints públicos usados en el flujo de registro:
// - Registro de veci, negocio y verificación telefónica.
// - Catálogos: países, departamentos, municipios, categorías de negocio.
// - Documento legal activo por código (para checkbox de aceptación).

import { api } from './apiClient';

// ── REGISTRO ──────────────────────────────────────────────────

export const registro = {
  verificarTelefonoVeci: (telefono) =>
    api.post('/api/holaveci/registro/veci/verificar-telefono', { telefono }, { skipAuth: true }),

  registrarVeci: (payload) =>
    api.post('/api/holaveci/registro/veci', payload, { skipAuth: true }),

  reactivarVeci: (payload) =>
    api.post('/api/holaveci/registro/veci/reactivar', payload, { skipAuth: true }),

  registrarNegocio: (payload) =>
    api.post('/api/holaveci/registro/negocio', payload, { skipAuth: true }),
};

// ── CATÁLOGOS GEOGRÁFICOS ────────────────────────────────────

export const geo = {
  paises: () =>
    api.get('/api/holaveci/paises', { skipAuth: true }),

  departamentos: (paisId) =>
    api.get('/api/holaveci/departamentos', { query: { paisId }, skipAuth: true }),

  // OJO: /api/holaveci/municipios es un endpoint de BÚSQUEDA POR TEXTO
  // (params q/limit) — ignora departamentoId si se lo mandas. El
  // filtrado real por departamento vive en /municipios-por-departamento.
  municipios: (departamentoId) =>
    api.get('/api/holaveci/municipios-por-departamento', { query: { departamentoId }, skipAuth: true }),
};

// ── CATÁLOGOS DE NEGOCIO ────────────────────────────────────

export const catalogos = {
  /** Categorías de negocio: fruver, market, drogueria, panaderia, etc. */
  categoriasNegocio: () =>
    api.get('/api/holaveci/categorias', { skipAuth: true }),
};

// ── DOCUMENTOS LEGALES ───────────────────────────────────────

export const legal = {
  /**
   * Devuelve la versión activa de un documento legal.
   * Códigos usados en registro: TC_VECI, TC_NEGOCIO, TC_DOMICILIARIO,
   * POLITICA_DATOS, AUTORIZACION_DATOS.
   */
  documento: (codigo) =>
    api.get(`/api/holaveci/legal/documentos/${encodeURIComponent(codigo)}`, { skipAuth: true }),
};
